import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { first } from 'rxjs/operators';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { VersionHistory } from 'src/app/shared/models/VersionHistory';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { DatePipe } from '@angular/common';
import { Constants } from 'src/app/shared/vo/Constants';

@Component({
  selector: 'app-version-history',
  templateUrl: './version-history.component.html',
  styleUrls: ['./version-history.component.scss'],
  providers: [MessageService, ConfirmationService]
})


export class VersionHistoryComponent implements OnInit {
  // Security 
  currentUser: any;
  token: string;
  onlyShow: string;
  security: SecurityDocument;
  languageToShow: String;


  // CRUD VARIABLES
  versionHistoryDialog: boolean;
  versionHistoryList: VersionHistory[];
  versionHistory: VersionHistory;
  selectedVersionHistoryList: VersionHistory[];
  roleList: any[];
  levelList: any[];
  submitted: boolean;

  // FAKE DATA VARIABLE
  fakeRoleData: any[];
  fakeLevelData: any[];

  // LABELS VARIABLES

  lbl_7: string = "Fecha de Releas";
  lbl_8: string = "Número de versión";
  lbl_9: string = "Resumen de cambios realizados";
  lbl_10: string = "Role";
  lbl_11: string = "Nivel";
  lbl_12: string = "Agregar";
  lbl_13: string = "Eliminar";
  lbl_14: string = "Buscar ... ";
  lbl_15: string = "En total hay ";
  lbl_16: string = "registros de versiones";
  lbl_17: string = "Mostrando";
  lbl_18: string = "de";
  lbl_19: string = "para un total de ";
  lbl_20: string = "Regresar";
  lbl_21: string = "Registro de versiones";
  lbl_22: string = "Agregar / Actualizar";
  lbl_23: string = "Guardar";
  lbl_24: string = "Cancelar";
  lbl_25: string = "es requerido";
  lbl_26: string = "Seleccionar";
  lbl_27: string = "¿ Estas seguro de eliminar el elemento seleccionado? ";
  lbl_28: string = "Confirmación";
  lbl_29: string = "Sí";
  lbl_30: string = "No";
  lbl_31: string = "Acción ejecutada correctamente";
  lbl_32: string = "No se ejecute por error durante proceso";
  lbl_33: string = "Completado exitosamente";
  lbl_34: string = "Error";
  lbl_35: string = "Id";
  lbl_36: string = "Acción ejecutada incorrectamente";
  lbl_37: string = "Id";
  lbl_38: string = "Fecha de Version";
  lbl_39: string = "Número de version";
  lbl_40: string = "Descripción";
  lbl_41: string = "Secre";
  lbl_42: string = "Treas";
  lbl_43: string = "Mater";
  lbl_44: string = "Escuela";
  lbl_45: string = "International";
  lbl_46: string = "Zona";
  lbl_47: string = "Nacional";
  lbl_48: string = "Local";
  lbl_49: string = "Valor";
  lbl_50: string = "¿ Estas seguro de crear el elemento seleccionado?";
  lbl_51: string = "¿ Estas seguro de actualizar el elemento seleccionado?";
  lbl_52: string = "Actualizar";
  lbl_53: string = "Verdadero";
  lbl_54: string = "Falso";

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService) {

    this.fakeRoleData = [
      { label: 'COORD', value: Constants.FUNCT_COORD },
      { label: 'SECRE', value: Constants.FUNCT_SECRE },
      { label: 'TREAS', value: Constants.FUNCT_TREAS },
      { label: 'MATER', value: Constants.FUNCT_MATE },
      { label: 'YOUNGS', value: Constants.FUNCT_YOUNG},
      { label: 'SCHOOL', value: Constants.FUNCT_EEPPG }
    ];
    this.fakeLevelData = [
      { label: 'INTERNAT', value: Constants.INTNAL_LEVELID },
      { label: 'ZONE', value: Constants.ZONE_LEVELID },
      { label: 'NATIONAL', value: Constants.NATIONAL_LEVELID },
      { label: 'LOCAL', value: Constants.LOCAL_LEVELID }
    ];

    this.onInitSecurity();
  }

  /**
   * The ngOnInit function is a lifecycle hook in Angular that is called after the component has been
   * initialized.
   */
  ngOnInit() {
  }


  /**
   * The function `onInitSecurity()` checks for a token and device parameter in the URL, and based on
   * their values, either authenticates the user or retrieves security information.
   */
  onInitSecurity() {
    this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.onlyShow = params.show;
    });
    if (!this.onlyShow) {
      this.onlyShow = "false";
    }
    this.getSecurity(this.token);

  }

  /**
   * The function "onInitApiElements" initializes the API elements by calling the "getVersionHistory",
   * "getRoles", and "getLevels" functions.
   */
  onInitApiElements() {
    this.getVersionHistory();
    this.getRoles();
    this.getLevels();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and then performs additional actions based on the response data.
   * @param {string} user - The "user" parameter is a string that represents the username or user
   * identifier for authentication. It is typically used to identify the user who is trying to log in or
   * access a certain resource.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity(this.token);
          } else {
          }
        },
        error => {
        });
  }

  /**
   * The function `getSecurity` retrieves security information based on a token profile and performs
   * additional actions.
   * @param {string} tokenProfile - The tokenProfile parameter is a string that represents the ID of a
   * security.
   */
  getSecurity(tokenProfile: string) {
    this.apiService.findSecurityById({ "id": tokenProfile }).then(
      data => {
        this.security = data;
        if (this.security.language == 'pt') {
          this.languageToShow = 'pt';
        } else if (this.security.language == 'en') {
          this.languageToShow = 'en';
        } else {
          this.languageToShow = 'es';
        }
        this.getTranslatedLabels();
        this.onInitApiElements();
      });
  }

  /**
   * The function `getVersionHistory()` retrieves all version history entries from an API service,
   * converts the data to JSON format, and assigns it to the `versionHistoryList` variable.
   */
  getVersionHistory() {
    // SELECT
    this.apiService.getAllVersionHistoryEntries({}).then(
      data => {
        this.versionHistoryList = this.convertPropertiesToJsonFormat(data);
        this.versionHistoryList = this.convertTopvilDateToFormatedDate(this.versionHistoryList);

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: this.lbl_36, detail: this.lbl_32, life: 3000 });
      });
  }

  /**
   * The getRoles function assigns the fakeRoleData array to the roleList variable.
   */
  getRoles() {
    // SELECT
    this.roleList = this.fakeRoleData;
  }

  /**
   * The function "getLevels" assigns the value of "fakeLevelData" to the variable "levelList".
   */
  getLevels() {
    // SELECT
    this.levelList = this.fakeLevelData;
  }

  /**
   * The function converts the versionDate property of each object in the versionHistoryList array from a
   * string to a formatted date.
   * @param {VersionHistory[]} versionHistoryList - An array of objects representing version history.
   * Each object should have a property called "versionDate" which is a string representing a date in the
   * format "YYYY-MM-DD".
   * @returns the updated versionHistoryList with the versionDateFormated property added to each
   * versionHistory object.
   */
  convertTopvilDateToFormatedDate(versionHistoryList: VersionHistory[]) {
    versionHistoryList.forEach(versionHistory => {
      versionHistory.versionDateFormated = this.tovpilUtils.convertStringToDate(versionHistory.versionDate);
    });
    return versionHistoryList;
  }

  /**
   * The function converts a formatted date to a specific date format used in the Topvil system.
   * @param {VersionHistory} versionHistory - The versionHistory parameter is an object that represents
   * the version history of something. It likely has properties such as version number, release date, and
   * any other relevant information about each version.
   * @returns the updated versionHistory object with the versionDate property converted to the Topvil
   * date format.
   */
  convertFormatedDateToTopvilDate(versionHistory: VersionHistory) {
    versionHistory.versionDate = this.tovpilUtils.dateToTovpilDate(versionHistory.versionDateFormated);
    return versionHistory;
  }

  /**
   * The function converts properties in a version history list to a JSON format using predefined
   * mappings.
   * @param versionHistoryList - An array of objects representing version history. Each object in the
   * array has properties that correspond to different roles and levels. The values of these properties
   * are either "1" or "0" indicating whether the role or level is present in that version history.
   * @returns the modified versionHistoryList with the rolesList and levelsList properties added to each
   * object in the list.
   */
  convertPropertiesToJsonFormat(versionHistoryList) {
    const roleMappings = {
      coord: {label: "COORD", value: Constants.FUNCT_COORD },
      secre: { label: "SECRE", value: Constants.FUNCT_SECRE },
      treas: { label: "TREAS", value: Constants.FUNCT_TREAS  },
      mater: { label: "MATER", value: Constants.FUNCT_MATE },
      youngs: { label: "YOUNGS", value: Constants.FUNCT_YOUNG },
      school: { label: "SCHOOL", value: Constants.FUNCT_EEPPG }      
    };

    const levelMappings = {
      internat: { label: "INTERNAT", value: Constants.INTNAL_LEVELID},
      zone: { label: "ZONE", value: Constants.ZONE_LEVELID },
      national: { label: "NATIONAL", value: Constants.NATIONAL_LEVELID },
      local: { label: "LOCAL", value: Constants.LOCAL_LEVELID }
    };

    versionHistoryList.forEach(versionHistory => {
      versionHistory.rolesList = [];
      versionHistory.levelsList = [];

      for (const [key, mapping] of Object.entries(roleMappings)) {
        if (String(versionHistory[key]) === "1") {
          versionHistory.rolesList.push(mapping);
        }
      }

      for (const [key, mapping] of Object.entries(levelMappings)) {
        if (String(versionHistory[key]) === "1") {
          versionHistory.levelsList.push(mapping);
        }
      }
    });

    return versionHistoryList;
  }

  /**
   * The function converts a JSON format object into a properties format object by mapping specific
   * labels to corresponding properties and resetting certain properties to '0'.
   * @param versionHistory - The `versionHistory` parameter is an object that contains information about
   * the version history. It has the following structure:
   * @returns the updated `versionHistory` object with the properties reset and the relevant properties
   * set to '1' based on the values in `versionHistory.rolesList` and `versionHistory.levelsList`.
   */
  convertJsonFormatToProperties(versionHistory) {
    const roleMappings = {
      COORD: 'coord',
      SECRE: 'secre',
      TREAS: 'treas',
      MATER: 'mater',
      YOUNGS: 'youngs',
      SCHOOL: 'school'
    };

    const levelMappings = {
      INTERNAT: 'internat',
      ZONE: 'zone',
      NATIONAL: 'national',
      LOCAL: 'local'
    };

    const propertiesToReset = ['coord','secre', 'treas', 'mater', 'youngs', 'school', 'internat', 'zone', 'national', 'local'];

    for (const property of propertiesToReset) {
      versionHistory[property] = '0';
    }

    const allVersions = [...versionHistory.rolesList, ...versionHistory.levelsList];

    for (const version of allVersions) {
      const label = version['label'].toUpperCase();
      if (roleMappings.hasOwnProperty(label)) {
        versionHistory[roleMappings[label]] = '1';
      } else if (levelMappings.hasOwnProperty(label)) {
        versionHistory[levelMappings[label]] = '1';
      }
    }

    return versionHistory;
  }

  /**
   * The function "hideDialog()" sets the "versionHistoryDialog" and "submitted" variables to false.
   */
  hideDialog() {
    this.versionHistoryDialog = false;
    this.submitted = false;
  }

  /**
   * The function "openNew" initializes variables and sets flags to open a version history dialog.
   */
  openNew() {
    this.versionHistory = null;
    this.versionHistory = {}
    this.submitted = false;
    this.versionHistoryDialog = true;
  }

  /**
   * The function "editVersionHistory" updates the version history and opens a dialog box.
   * @param {VersionHistory} versionHistory - The versionHistory parameter is an object that represents
   * the version history of a software application. It likely contains information such as the version
   * number, release date, and any changes or updates made in each version.
   */
  editVersionHistory(versionHistory: VersionHistory) {
    this.versionHistory = { ...versionHistory };
    this.versionHistoryDialog = true;
  }

  /**
   * The function `deleteVersionHistory` confirms the deletion of a version history entry and removes it
   * from the version history list.
   * @param {VersionHistory} versionHistory - The `versionHistory` parameter is an object that represents
   * a specific version history. It likely has properties such as `id`, which is used to identify the
   * version history in the `versionHistoryList` array.
   */
  deleteVersionHistory(versionHistory: VersionHistory) {
    let param = {
      "id": versionHistory.id,
      "versionDate": versionHistory.versionDate,
      "versionNum": versionHistory.versionNum,
      "summary": versionHistory.summary,
      "coord": versionHistory.coord,
      "secre": versionHistory.secre,
      "treas": versionHistory.treas,
      "mater": versionHistory.mater,
      "youngs": versionHistory.youngs,
      "school": versionHistory.school,
      "internat": versionHistory.internat,
      "zone": versionHistory.zone,
      "national": versionHistory.national,
      "local": versionHistory.local,
    }
    this.confirmationService.confirm({
      message: this.lbl_27 + ' version ' + versionHistory.versionNum,
      header: this.lbl_28,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.apiService.deleteVersionHistoryEntry({ body: param }).then(
          data => {
            this.messageService.add({ severity: 'success', summary: this.lbl_33, detail: this.lbl_31, life: 3000 });
            this.getVersionHistory();
          }).catch(error => {
            console.error(error);
            this.messageService.add({ severity: 'error', summary: this.lbl_36, detail: this.lbl_32, life: 3000 });
          });
      },
      reject: () => {
        this.getVersionHistory();
      },
      acceptLabel: this.lbl_29,
      rejectLabel: this.lbl_30,
    });
  }

  /**
   * The function `deleteSelectedVersionHistoryList()` confirms with the user before deleting selected
   * items from the `versionHistoryList` array and displays a success message afterwards.
   */
  deleteSelectedVersionHistoryList() {
    this.confirmationService.confirm({
      message: this.lbl_27,
      header: this.lbl_28,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // DELETE MANY
        for (const selectedVersion of this.selectedVersionHistoryList) {
          this.apiService.deleteVersionHistoryEntry({
            body: {
              "id": selectedVersion.id,
              "versionDate": selectedVersion.versionDate,
              "versionNum": selectedVersion.versionNum,
              "summary": selectedVersion.summary,
              "coord": selectedVersion.coord,
              "secre": selectedVersion.secre,
              "treas": selectedVersion.treas,
              "mater": selectedVersion.mater,
              "youngs": selectedVersion.youngs,
              "school": selectedVersion.school,
              "internat": selectedVersion.internat,
              "zone": selectedVersion.zone,
              "national": selectedVersion.national,
              "local": selectedVersion.local,
            }
          }).then(
            data => {
              this.messageService.add({ severity: 'success', summary: this.lbl_33, detail: this.lbl_31, life: 3000 });
              this.getVersionHistory();
            }).catch(error => {
              console.error(error);
              this.messageService.add({ severity: 'error', summary: this.lbl_36, detail: this.lbl_32, life: 3000 });
            });
        }
        this.selectedVersionHistoryList = null;
      },
      acceptLabel: this.lbl_29,
      rejectLabel: this.lbl_30,
    });
  }

  /**
   * The function saves the version history by either updating an existing version or creating a new one.
   */
  saveVersionHistory() {
    this.submitted = true;
    this.versionHistory = this.convertJsonFormatToProperties(this.versionHistory);
    this.versionHistory = this.convertFormatedDateToTopvilDate(this.versionHistory);

    if (this.versionHistory) {
      if (this.versionHistory.id) {
        // UPDATE 
        this.updateVersionHistory(this.versionHistory);
        this.getVersionHistory();
      }
      else {
        // CREATE 
        this.createOneVersionHistory(this.versionHistory);
        this.getVersionHistory();
      }

      this.versionHistoryDialog = false;
      this.versionHistory = null;
    }
  }

  /**
   * The function `createOneVersionHistory` creates a new version history entry and displays a
   * confirmation dialog before doing so.
   * @param {VersionHistory} versionHistory - The `versionHistory` parameter is an object that contains
   * the following properties:
   */
  createOneVersionHistory(versionHistory: VersionHistory) {
    let param = {
      "id": "",
      "versionDate": versionHistory.versionDate,
      "versionNum": versionHistory.versionNum,
      "summary": versionHistory.summary,
      "summaryen": versionHistory.summaryen,
      "summarypt": versionHistory.summarypt,
      "coord": versionHistory.coord,
      "secre": versionHistory.secre,
      "treas": versionHistory.treas,
      "mater": versionHistory.mater,
      "youngs": versionHistory.youngs,
      "school": versionHistory.school,
      "internat": versionHistory.internat,
      "zone": versionHistory.zone,
      "national": versionHistory.national,
      "local": versionHistory.local,
    }
    this.confirmationService.confirm({
      message: this.lbl_50,
      header: this.lbl_28,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.apiService.createVersionHistoryEntry(param).then(
          data => {
            this.messageService.add({ severity: 'success', summary: this.lbl_33, detail: this.lbl_31, life: 3000 });
            this.getVersionHistory();
          }).catch(error => {
            console.error(error);
            this.messageService.add({ severity: 'error', summary: this.lbl_36, detail: this.lbl_32, life: 3000 });
          });
      },
      reject: () => {
        this.getVersionHistory();
      },
      acceptLabel: this.lbl_29,
      rejectLabel: this.lbl_30,
    });
  }

  /**
   * The `updateVersionHistory` function confirms with the user before creating a new version history
   * entry and displaying success or error messages accordingly.
   * @param {VersionHistory} versionHistory - The `versionHistory` parameter is an object that contains
   * the information about a version history entry. It has the following properties:
   */
  updateVersionHistory(versionHistory: VersionHistory) {
    let param = {
      "id": versionHistory.id,
      "versionDate": versionHistory.versionDate,
      "versionNum": versionHistory.versionNum,
      "summary": versionHistory.summary,
      "summaryen": versionHistory.summaryen,
      "summarypt": versionHistory.summarypt,
      "coord": versionHistory.coord,
      "secre": versionHistory.secre,
      "treas": versionHistory.treas,
      "mater": versionHistory.mater,
      "youngs": versionHistory.youngs,
      "school": versionHistory.school,
      "internat": versionHistory.internat,
      "zone": versionHistory.zone,
      "national": versionHistory.national,
      "local": versionHistory.local,
    }
    this.apiService.updateVersionHistoryEntry(param).then(
      data => {

        this.messageService.add({ severity: 'success', summary: this.lbl_33, detail: this.lbl_31, life: 3000 });
        this.getVersionHistory();
      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: this.lbl_36, detail: this.lbl_32, life: 3000 });
      });
  }


  exportExcelMng() {
    if (this.versionHistoryList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.versionHistoryList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.versionHistoryList.map((item) => ({
        "FECHA_VERSION": this.formatDate(item.versionDate) || 'S/N',
        "NUMERO_VERSION": item.versionNum || 'S/N',
        "DESCRIPCION": item.summary || 'S/N'
      }));

      this.filesService.tovpilExportXLSX(filteredJSON, 'listVersionHistory_');

    }
  }

  exportPdfMng() {
    if (this.versionHistoryList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.versionHistoryList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.versionHistoryList.map((item) => ({
        "FECHA_VERSION": this.formatDate(item.versionDate) || 'S/N',
        "NUMERO_VERSION": item.versionNum || 'S/N',
        "DESCRIPCION": item.summary || 'S/N'
      }));


      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listVersionHistory_');

    }
  }

  datePipe: DatePipe = new DatePipe('en-US');

  /**
 * This function formats a given date string into a specific format using the datePipe module in
 * TypeScript.
 * @param {string} dateString - A string representing a date in any valid format (e.g. "2021-10-15" or
 * "Oct 15, 2021").
 * @returns The function `formatDate` is returning a formatted date string in the format of
 * 'dd-MM-yyyy'. The input parameter `dateString` is being passed to the `datePipe.transform` method to
 * format the date. The formatted date string is then returned by the function.
 */
  formatDate(dateString: string) {

    const formattedDate = this.datePipe.transform(this.tovpilUtils.convertStringToDate(dateString), 'yyyy-MM-dd');
    return formattedDate;
  }

  /**
   * The goBack function closes the current window.
   */
  goBack() {
    window.close();
  }

  /**
   * The function `getTranslatedLabels()` retrieves translated labels from an API and stores them in a
   * map.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': []
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
      });
  }

  /**
   * The function checks if all the required fields in the versionHistory object are filled in and
   * returns a boolean value indicating the validity of the form.
   * @returns A boolean value is being returned.
   */
  isFormValid() {
    const hasRequiredValues =
      this.versionHistory.versionDateFormated &&
      this.versionHistory.versionNum &&
      this.versionHistory.summary &&
      this.versionHistory.summaryen &&
      this.versionHistory.summarypt &&
      this.versionHistory.rolesList
      && this.versionHistory.levelsList;

    if (hasRequiredValues) {
      this.saveVersionHistory();
    } else {
      this.messageService.add({ severity: 'error', summary: this.lbl_36, detail: this.lbl_32, life: 3000 });
    }
  }

}
